"use client";

import { useEffect, useState } from "react";
import { useFormValue } from "sanity";
import { getCampaignState } from "@/lib/scheduledCampaign";
import { CAMPAIGN_STATUS, campaignStatusHeadline } from "@/sanity/lib/campaignStatus";

/**
 * Display-only status card at the top of the Banner Campaign: what the site shows right now.
 * Attached via `components.field` on a readOnly field that stores nothing.
 */

const RECHECK_MS = 30_000;

const MUTED = "color-mix(in srgb, var(--card-fg-color, currentColor) 70%, transparent)";

export function CampaignStatusField() {
  const isEnabled = useFormValue(["isEnabled"]) as boolean | undefined;
  const startDate = useFormValue(["startDate"]) as string | undefined;
  const endDate = useFormValue(["endDate"]) as string | undefined;

  // re-render so the card flips at the boundaries while the form is open
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), RECHECK_MS);
    return () => window.clearInterval(id);
  }, []);

  const state = getCampaignState({ isEnabled, startDate, endDate }, now);
  const { icon, label, color } = CAMPAIGN_STATUS[state];

  return (
    <div
      style={{
        borderRadius: "0.375rem",
        borderLeft: `3px solid ${color}`,
        background: `color-mix(in srgb, ${color} 8%, transparent)`,
        padding: "0.625rem 0.875rem",
        fontSize: "0.8125rem",
        lineHeight: 1.45,
      }}
    >
      <p style={{ margin: 0, fontWeight: 700 }}>
        {icon} {label}
      </p>
      <p style={{ margin: "0.25rem 0 0" }}>{campaignStatusHeadline(state, startDate, endDate)}</p>
      <p style={{ margin: "0.375rem 0 0", fontSize: "0.6875rem", color: MUTED }}>
        Reflects this form, including unpublished changes. The site follows the published version.
      </p>
    </div>
  );
}
